// eslint-disable-next-line
import ProfilePlaceholderIcon from '!!raw-loader!@img/icons/profile_placeholder.svg';
import type { PersonReferenceNode } from '@newStore/documentUI/documentUITypes';
import { settings } from '../../../../../../config/settings';
import './PersonReferenceRow.scss';

const PersonReferenceRow: React.FC<{ contentNode: PersonReferenceNode }> = ({ contentNode }) => {
  const { person, loading } = contentNode;

  if (!person && !loading) {
    return <div>Deze node verwijst naar verwijderde data.</div>;
  }

  if (person) {
    return (
      <div className={'referenced-item'} key={person.href}>
        {person.profilePicture && (
          <img
            src={`${settings.apisAndUrls.api}${person.profilePicture}`}
            alt="Profile picture"
            style={{ height: '40px', width: '40px' }}
          />
        )}
        {!person.profilePicture && (
          <span
            style={{ display: 'inline-flex' }}
            dangerouslySetInnerHTML={{ __html: ProfilePlaceholderIcon }}
          />
        )}
        <div className="name" dangerouslySetInnerHTML={{ __html: person.fullName }} />
        <div className="email">{person.email}</div>
      </div>
    );
  }

  return <div className="shimmer" style={{ height: '40px' }} />;
};

export default PersonReferenceRow;
